// Scrolls its element to the top in two cases:
//   1. The server pushes a "scroll-to-top" event — e.g. surfacing the
//      brochure-extraction notice when uploading from the bottom of the survey
//      modal (ENA-9425). Smooth-scrolls; accepts an optional detail override.
//   2. A tracked `data-scroll-top-key` attribute changes between patches — e.g.
//      selecting a different account in the list, so the content panel doesn't
//      keep the previous account's scroll position. Instant.
//
// Distinct from ScrollTo to avoid broadcasting to other ScrollTo-hooked elements.
const ScrollToTop = {
  mounted() {
    this.scrollKey = this.el.dataset.scrollTopKey
    this.handleEvent("scroll-to-top", (detail) => {
      this.el.scrollTo({ behavior: "smooth", ...detail, top: 0 })
    })
  },
  updated() {
    const key = this.el.dataset.scrollTopKey
    if (key !== undefined && key !== this.scrollKey) {
      this.el.scrollTop = 0
      this.scrollKey = key
    }
  },
}

export default ScrollToTop
